// Temi's mark. The design system is explicit that the assistant is only ever
// represented by this sparkle — the Lumi wordmark is the product logo and must
// never stand in for the AI.
export const TemiSparkIcon = ({
  width = "24",
  height = "24",
  primaryColor = "#7647EE",
  secondaryColor = "#AD91F5",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.2L14 8.2L20 10.2L14 12.2L12 18.2L10 12.2L4 10.2L10 8.2L12 2.2Z"
        fill={primaryColor}
      />
      <path
        d="M18.6 14.6L19.5 17.3L22.2 18.2L19.5 19.1L18.6 21.8L17.7 19.1L15 18.2L17.7 17.3L18.6 14.6Z"
        fill={secondaryColor}
      />
    </svg>
  );
};
